<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed inset-x-0 top-0 z-20">
		<div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
       <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
			<div class="flex items-center px-4 py-4">
				<div class="flex items-center w-full">
					<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
					<span class="text-base text-content font-medium ml-4">Edit Enquiry</span>
				</div>
			</div>
		</div>
    </div>
    <div class="pt-20 bg-white">
    <div class="bg-white min-h-screen p-4">
       <Enquiry :enquiry="EditEnquiry" :editSubmitFn="goToStep1" :getProperty="getProperty" :propertyList="propertyList"/>
    </div>
  </div>
	</div>
</template>
<script>
import Enquiry from '@/components/Enquiry/New.vue';
import {prepareEnquiryParams} from '@/assets/scripts/utility.js';
export default {
  components: {
    Enquiry
  },
  data () {
    return {
      EditEnquiry: {},
      propertyList: [],
    }
  },
  created() {
    this.$axios.get(`mobile_crm/leads/${this.$route.params.uuid}`)
    .then((res) => {
      this.EditEnquiry = res.data.lead
      if (this.EditEnquiry.preferred_project_id) {
        this.$axios.get(`mobile_crm/leads/properties?project_id=${this.EditEnquiry.preferred_project_id}`)
        .then((res) => {
          this.propertyList = res.data
          })
        .catch((err) => console.log(err));
      }
      let step0_data = this.$store.getters.newEnquiryData
      if (Object.keys(step0_data).length > 0) {
        this.EditEnquiry = step0_data
      }
    })
    .catch((err) => console.log(err));
  },
  methods: {
    getProperty() {
      const pp = this.EditEnquiry.preferred_project_id
      const projectId =
        pp != null && typeof pp === 'object' ? pp.id : pp
      if (projectId == null || projectId === '') return
      this.$axios.get(`mobile_crm/leads/properties?project_id=${projectId}`)
      .then((res) => {
        this.propertyList = res.data
      })
      .catch((err) => console.log(err));
    },
    goToStep1(){
      let apiParams = {}
      apiParams = prepareEnquiryParams(this.EditEnquiry);
      let editEnquiryData = apiParams
      this.$store.dispatch('setnewEnquiryData', editEnquiryData);
      this.$router.push({name: 'EditNextEnquiry'});
    },
  }
}
</script>
<style scoped>

</style>